<div class="mini-calendar">
    <div class="row text-center" id="nav-buttons">
        <div class="col-sm-3 col-xs-12">
            <div tabindex="0" id="previous" class="btn-nav" mwlCalendarPreviousView [view]="view"
                [(viewDate)]="viewDate" (viewDateChange)="activeDayIsOpen = false" translate>
                <i class="fa fa-arrow-left"></i>
            </div>
        </div>
        <div class="col-sm-6 col-xs-12 calendar-title">
            {{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}
        </div>
        <div class="col-sm-3 col-xs-12">
            <div tabindex="0" id="next" class="btn-nav" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                (viewDateChange)="activeDayIsOpen = false" translate>
                <i class="fa fa-arrow-right"></i>
            </div>
        </div>
    </div>
    <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" (dayClicked)="dayClicked($event)"
        (beforeViewRender)="beforeMonthViewRender($event)" [refresh]="refresh">
    </mwl-calendar-month-view>
    <strong>Scheduled events:</strong><br>
    <div class="mini-legend">
        <div class="item scheduled" translate>
            <i class="bullet"></i>calendar.legend.scheduled
        </div>
    </div>
    <strong>Completed events:</strong><br>
    <legend-component></legend-component>

</div>